import { makeStyles } from '@material-ui/core';
import f002Image from '../assets/f002.png';

export const collapsedDrawerWidth = 72;
export const expandedDrawerWidth = 280;
export const TRIAL_BANNER_HEIGHT = 44;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    height: '100%',
    backgroundColor: '#f8f9fa',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      height: '100%',
      minHeight: 0,
      maxHeight: '100%',
      overflow: 'hidden',
    },
  },
  trialBannerWrapper: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 12,
  },
  appBar: (props) => ({
    flexShrink: 0,
    zIndex: 10,
    backgroundColor: 'transparent !important',
    background: 'transparent !important',
    color: '#3b82f6',
    boxShadow: 'none !important',
    borderBottom: 'none',
    marginLeft: props.drawerWidth,
    width: `calc(100% - ${props.drawerWidth}px)`,
    transition: 'margin-left 0.2s ease, width 0.2s ease',
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 'env(safe-area-inset-top, 0px)',
    },
  }),
  toolbar: {
    minHeight: '64px',
    padding: '0 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      minHeight: '44px',
      padding: '0 12px',
    },
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flex: 1,
  },
  menuButton: {
    display: 'none',
    color: '#3b82f6',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none !important',
    },
  },
  backButtonConversation: {
    display: 'none',
    color: '#3b82f6',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  searchContainer: {
    position: 'relative',
    backgroundColor: '#f3f4f6',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    width: '100%',
    maxWidth: '400px',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: '#3b82f6',
    },
    '&:focus-within': {
      borderColor: '#3b82f6',
      boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  mobileLogo: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
      height: '32px',
      '& img': {
        height: '28px',
        width: '28px',
        objectFit: 'contain',
        borderRadius: '6px',
      },
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#000000',
  },
  searchButton: (props) => ({
    position: 'absolute',
    right: '4px',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: props.primaryColor || '#3b82f6',
    color: '#ffffff',
    borderRadius: '8px',
    padding: '8px',
    minWidth: '36px',
    height: '36px',
    '&:hover': {
      backgroundColor: props.primaryColor || '#2563eb',
      filter: 'brightness(0.9)',
    },
  }),
  inputRoot: {
    color: '#3b82f6',
    width: '100%',
  },
  inputInput: {
    padding: theme.spacing(1.5, 6, 1.5, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    fontSize: '14px',
    color: '#3b82f6',
    '&::placeholder': {
      color: '#000000',
      opacity: 1,
    },
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '8px',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      gap: '4px',
      flexShrink: 0,
    },
  },
  iconButton: (props) => ({
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    color: 'var(--wl-menu-header-icon, var(--wl-menu-icon, #ffffff))',
    backgroundColor: props.primaryColor || '#3b82f6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    '& .MuiSvgIcon-root': {
      fontSize: '20px',
      color: 'var(--wl-menu-header-icon, var(--wl-menu-icon, #ffffff))',
    },
    '&:hover': {
      backgroundColor: props.primaryColor || '#2563eb',
      filter: 'brightness(0.9)',
      transform: 'scale(1.05)',
    },
    [theme.breakpoints.down('sm')]: {
      width: '36px',
      height: '36px',
      '& .MuiSvgIcon-root': { fontSize: '18px' },
    },
  }),
  drawer: (props) => ({
    width: props.drawerWidth,
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  }),
  drawerPaper: (props) => ({
    width: props.drawerWidth,
    backgroundColor: 'var(--wl-menu-bg, #3b82f6)',
    borderRight: 'none',
    borderTopRightRadius: 18,
    borderBottomRightRadius: 18,
    overflowX: 'hidden',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    transition: 'width 0.2s ease, background-color 0.3s ease',
    [theme.breakpoints.down('md')]: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  }),
  mobileDrawer: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  drawerHeader: (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: props.drawerWidth > collapsedDrawerWidth ? 'space-between' : 'center',
    gap: '8px',
    padding: props.drawerWidth > collapsedDrawerWidth ? '16px 12px' : '16px 0',
    minHeight: '64px',
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: 'var(--wl-menu-bg, #3b82f6)',
  }),
  drawerHeaderLogo: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
  },
  menuToggleButton: {
    color: 'var(--wl-menu-text, #fff)',
    padding: '6px',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
  menuToggleIconCombo: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    '& .MuiSvgIcon-root': {
      fontSize: 20,
      color: 'var(--wl-menu-icon, #fff)',
    },
  },
  logo: (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: props.drawerWidth > collapsedDrawerWidth ? 'flex-start' : 'center',
    cursor: 'pointer',
    width: '100%',
  }),
  logoIcon: (props) => ({
    fontSize: props.drawerWidth > collapsedDrawerWidth ? '36px' : '32px',
    color: '#3b82f6',
    transition: 'font-size 0.2s ease',
  }),
  logoText: {
    display: 'none',
  },
  companyLogo: (props) => ({
    height: '36px',
    width: props.drawerWidth > collapsedDrawerWidth ? '160px' : '36px',
    objectFit: 'contain',
    borderRadius: '8px',
    transition: 'width 0.2s ease',
  }),
  sidebarContent: (props) => ({
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: props.drawerWidth > collapsedDrawerWidth ? '12px 8px' : '8px 0',
    width: '100%',
    boxSizing: 'border-box',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  }),
  menuSectionLabel: (props) => ({
    display: props.drawerWidth > collapsedDrawerWidth ? 'block' : 'none',
    fontSize: '0.68rem',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: 'var(--wl-menu-text, rgba(255, 255, 255, 0.75))',
    margin: '12px 16px 4px',
  }),
  menuList: (props) => ({
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: props.drawerWidth > collapsedDrawerWidth ? 'stretch' : 'center',
    gap: '4px',
  }),
  menuItem: (props) => ({
    padding: props.drawerWidth > collapsedDrawerWidth ? '10px 14px' : '12px',
    margin: '0',
    borderRadius: '12px',
    transition: 'all 0.2s ease',
    minHeight: 'auto',
    width: props.drawerWidth > collapsedDrawerWidth ? '100%' : '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: props.drawerWidth > collapsedDrawerWidth ? 'flex-start' : 'center',
    gap: props.drawerWidth > collapsedDrawerWidth ? '12px' : 0,
    '&:hover:not(.active)': {
      backgroundColor: 'var(--wl-menu-hover-bg, rgba(0, 0, 0, 0.12))',
      '& .MuiListItemIcon-root': {
        color: 'var(--wl-menu-hover-text, #ffffff)',
      },
      '& .MuiListItemText-primary': {
        color: 'var(--wl-menu-hover-text, #ffffff)',
      },
    },
    '&.active': {
      backgroundColor: 'var(--wl-menu-active-bg, rgba(0, 0, 0, 0.18))',
      borderLeft: '3px solid var(--wl-menu-active-indicator, #7DFFAF)',
      '& .MuiListItemIcon-root': {
        color: 'var(--wl-menu-active-text, #ffffff)',
      },
      '& .MuiListItemText-primary': {
        color: 'var(--wl-menu-active-text, #ffffff)',
      },
    },
  }),
  menuIcon: (props) => ({
    minWidth: props.drawerWidth > collapsedDrawerWidth ? 'auto' : 'initial',
    color: 'var(--wl-menu-icon, #ffffff)',
    margin: props.drawerWidth > collapsedDrawerWidth ? '0 0 0 4px' : 0,
    '& .MuiSvgIcon-root': {
      fontSize: '22px',
    },
  }),
  menuText: (props) => ({
    display: props.drawerWidth > collapsedDrawerWidth ? 'block' : 'none',
    color: 'var(--wl-menu-text, #f1f5f9)',
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '0.2px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0,
  }),
  menuItemExpandIcon: (props) => ({
    marginLeft: 'auto',
    display: props.drawerWidth > collapsedDrawerWidth ? 'flex' : 'none',
    color: 'var(--wl-menu-text, #f1f5f9)',
    transition: 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    '& .MuiSvgIcon-root': { fontSize: 20 },
  }),
  subMenuWrapper: {
    overflowY: 'auto',
    overflowX: 'hidden',
    transition:
      'max-height 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94), padding 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    maxHeight: '420px',
    opacity: 1,
    paddingBottom: '8px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': { display: 'none' },
  },
  subMenuItem: (props) => ({
    padding: props.drawerWidth > collapsedDrawerWidth ? '8px 16px' : 0,
    minHeight: 'auto',
    borderRadius: '8px',
    marginLeft: props.drawerWidth > collapsedDrawerWidth ? '0' : 0,
    width: props.drawerWidth > collapsedDrawerWidth ? 'calc(100% - 24px)' : '100%',
    justifyContent: 'center',
    color: 'var(--wl-menu-text, #e2e8f0)',
    transition: 'background-color 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    '&:hover:not(.active)': {
      backgroundColor: 'var(--wl-menu-hover-bg, rgba(0, 0, 0, 0.12))',
      color: 'var(--wl-menu-hover-text, #ffffff)',
      '& .MuiListItemIcon-root': {
        color: 'var(--wl-menu-hover-text, #ffffff)',
      },
    },
    '&.active': {
      backgroundColor: 'var(--wl-menu-active-bg, rgba(0, 0, 0, 0.18))',
      color: 'var(--wl-menu-active-text, #ffffff)',
      borderLeft: '3px solid var(--wl-menu-active-indicator, #7DFFAF)',
      '& .MuiListItemIcon-root': {
        color: 'var(--wl-menu-active-text, #ffffff)',
      },
    },
  }),
  subMenuText: (props) => ({
    display: props.drawerWidth > collapsedDrawerWidth ? 'block' : 'none',
    fontSize: '13px',
    fontWeight: 500,
    color: 'inherit',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0,
  }),
  subMenuItemIcon: {
    minWidth: 28,
    color: 'var(--wl-menu-icon, #e2e8f0)',
    '& .MuiSvgIcon-root': { fontSize: 18 },
  },
  badge: {
    '& .MuiBadge-badge': {
      backgroundColor: '#ef4444',
      color: '#ffffff',
      fontSize: '10px',
      minWidth: '16px',
      height: '16px',
      top: '4px',
      right: '4px',
    },
  },
  menuDivider: (props) => ({
    width: props.drawerWidth > collapsedDrawerWidth ? '80%' : '32px',
    height: '1px',
    backgroundColor: 'var(--wl-menu-divider, rgba(255, 255, 255, 0.1))',
    margin: props.drawerWidth > collapsedDrawerWidth ? '12px auto' : '8px auto',
  }),
  content: () => ({
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    marginTop: '64px',
    backgroundColor: '#f8f9fa',
    display: 'flex',
    flexDirection: 'column',
    transition: 'width 0.2s ease',
    [theme.breakpoints.down('md')]: {
      marginTop: '64px',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 'calc(44px + env(safe-area-inset-top, 0px))',
      overflow: 'hidden',
      minHeight: 0,
    },
  }),
  contentWithBanner: {
    marginTop: `${64 + TRIAL_BANNER_HEIGHT}px !important`,
    [theme.breakpoints.down('sm')]: {
      marginTop: `calc(44px + ${TRIAL_BANNER_HEIGHT}px + env(safe-area-inset-top, 0px)) !important`,
    },
  },
  contentScrollWrapper: () => ({
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 'calc(76px + env(safe-area-inset-bottom, 0px))',
    },
  }),
  contentScrollWrapperNoNavPadding: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '0 !important',
    },
  },
  contentScrollInner: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    '& > *': {
      flex: 1,
      minHeight: 0,
    },
  },
  mobileBottomNav: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexShrink: 0,
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      minHeight: '76px',
      paddingTop: '6px',
      paddingLeft: '8px',
      paddingRight: '8px',
      paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      backgroundColor: '#ffffff',
      borderTop: '1px solid #e5e7eb',
      justifyContent: 'space-around',
      alignItems: 'center',
      zIndex: 9,
      boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.08)',
    },
  },
  mobileNavItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px 12px 8px',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    color: '#000000',
    minWidth: '52px',
    minHeight: '44px',
    boxSizing: 'border-box',
    '&:hover': {
      backgroundColor: 'rgba(59, 130, 246, 0.08)',
    },
    '&.active': {
      color: '#3b82f6',
      backgroundColor: 'rgba(59, 130, 246, 0.12)',
      '& $mobileNavIcon': {
        color: '#3b82f6',
      },
      '& $mobileNavLabel': {
        color: '#3b82f6',
        fontWeight: 600,
      },
    },
  },
  mobileNavIcon: {
    fontSize: '22px',
    marginBottom: '2px',
  },
  mobileNavLabel: {
    fontSize: '10px',
    fontWeight: 500,
    textAlign: 'center',
    lineHeight: 1.2,
  },
  mobileNavHomeBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '56px',
    height: '56px',
    flexShrink: 0,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
    color: '#ffffff',
    boxShadow: '0 4px 15px rgba(59, 130, 246, 0.4)',
    marginTop: '-24px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: '0 6px 20px rgba(59, 130, 246, 0.5)',
    },
    '&:active': {
      transform: 'scale(0.95)',
    },
  },
  mobileNavHomeIcon: {
    fontSize: '28px',
  },
  contentWithMobileNav: {},
  hideOnMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'none !important',
    },
  },

  // ── Mobile "Mais" sheet ────────────────────────────────────────────────────
  '@keyframes slideUpSheet': {
    from: { transform: 'translateY(110%)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
  },
  '@keyframes fadeInBackdrop': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },

  mobileNavSheetBackdrop: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.35)',
      backdropFilter: 'blur(3px)',
      WebkitBackdropFilter: 'blur(3px)',
      zIndex: 18,
      animation: '$fadeInBackdrop 0.2s ease',
    },
  },

  mobileNavSheet: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      bottom: 'calc(72px + env(safe-area-inset-bottom, 0px))',
      left: '12px',
      right: '12px',
      backgroundColor: '#ffffff',
      borderRadius: '20px',
      padding: '10px 16px 20px',
      zIndex: 19,
      boxShadow: '0 -2px 40px rgba(0, 0, 0, 0.18), 0 8px 32px rgba(0, 0, 0, 0.12)',
      animation: '$slideUpSheet 0.3s cubic-bezier(0.34, 1.4, 0.64, 1)',
    },
  },

  mobileNavSheetHandle: {
    width: 40,
    height: 4,
    borderRadius: 2,
    backgroundColor: '#e5e7eb',
    margin: '4px auto 14px',
    flexShrink: 0,
  },

  mobileNavSheetTitle: {
    fontSize: '11px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: '#9ca3af',
    marginBottom: '12px',
    paddingLeft: '4px',
  },

  mobileNavSheetGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '8px',
  },

  mobileNavSheetItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '5px',
    padding: '12px 4px 10px',
    borderRadius: '14px',
    cursor: 'pointer',
    color: '#374151',
    backgroundColor: '#f9fafb',
    border: '1px solid transparent',
    transition: 'all 0.15s ease',
    minHeight: '72px',
    '&:hover': {
      backgroundColor: 'rgba(59, 130, 246, 0.08)',
      border: '1px solid rgba(59, 130, 246, 0.2)',
      color: '#3b82f6',
      transform: 'scale(1.04)',
    },
    '&:active': {
      transform: 'scale(0.94)',
    },
    '&.active': {
      backgroundColor: 'rgba(59, 130, 246, 0.1)',
      border: '1px solid rgba(59, 130, 246, 0.3)',
      color: '#3b82f6',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '26px',
    },
  },

  mobileNavSheetItemLabel: {
    fontSize: '10px',
    fontWeight: 500,
    textAlign: 'center',
    lineHeight: 1.2,
    color: 'inherit',
  },
  submenuPopoverPaper: {
    marginTop: '4px',
    marginLeft: 0,
    borderRadius: '12px',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
    backgroundColor: 'var(--wl-menu-bg, #3b82f6)',
    color: 'var(--wl-menu-text, #f1f5f9)',
    border: '1px solid var(--wl-menu-divider, rgba(255, 255, 255, 0.12))',
    minWidth: 180,
    left: `${collapsedDrawerWidth}px !important`,
    '& .MuiListItem-root': {
      fontSize: '14px',
    },
  },
  submenuPopoverItem: () => ({
    padding: '10px 16px',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '12px',
    color: 'var(--wl-menu-text, #f1f5f9)',
    '& .MuiListItemIcon-root': {
      minWidth: 28,
      color: 'var(--wl-menu-icon, #ffffff)',
      '& .MuiSvgIcon-root': { fontSize: 18 },
    },
    '&:hover': {
      borderRadius: '12px',
      backgroundColor: 'var(--wl-menu-hover-bg, rgba(0, 0, 0, 0.12))',
      color: 'var(--wl-menu-hover-text, #ffffff)',
      '& .MuiListItemIcon-root': {
        color: 'var(--wl-menu-hover-text, #ffffff)',
      },
    },
    '&.active': {
      borderRadius: '12px',
      backgroundColor: 'var(--wl-menu-active-bg, rgba(0, 0, 0, 0.18))',
      color: 'var(--wl-menu-active-text, #ffffff)',
      borderLeft: '3px solid var(--wl-menu-active-indicator, #7DFFAF)',
      '& .MuiListItemIcon-root': {
        color: 'var(--wl-menu-active-text, #ffffff)',
      },
    },
  }),
  userMenuPaper: {
    borderRadius: 16,
    minWidth: 272,
    padding: '14px 12px 12px',
    boxShadow: '0 8px 28px rgba(0,0,0,0.13)',
    border: '1px solid #f3f4f6',
    marginTop: 8,
  },
  userMenuProfile: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '4px 6px 12px',
    cursor: 'pointer',
    borderRadius: 10,
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: '#f9fafb',
    },
  },
  userMenuAvatar: (props) => ({
    width: 40,
    height: 40,
    backgroundColor: props.primaryColor || '#3b82f6',
    fontSize: '1rem',
    fontWeight: 700,
    flexShrink: 0,
  }),
  userMenuName: {
    fontWeight: 700,
    fontSize: 14,
    color: '#111827',
    lineHeight: 1.3,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  userMenuRole: {
    fontSize: 11.5,
    color: '#9ca3af',
    marginTop: 2,
    lineHeight: 1.4,
  },
  userMenuEditChip: {
    marginLeft: 'auto',
    backgroundColor: '#f3f4f6',
    borderRadius: 6,
    padding: '3px 8px',
    flexShrink: 0,
  },
  userMenuEditChipText: {
    fontSize: 11,
    fontWeight: 600,
    color: '#6b7280',
  },
  userMenuDivider: {
    margin: '0 0 10px',
    backgroundColor: '#f3f4f6',
  },
  userMenuAction: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    borderRadius: 10,
    padding: '10px 12px',
    cursor: 'pointer',
    transition: 'background-color 0.15s ease',
    marginBottom: 6,
    '&:hover': {
      backgroundColor: '#f9fafb',
    },
  },
  userMenuActionLogout: {
    marginBottom: 0,
    '&:hover': {
      backgroundColor: '#fef2f2',
    },
  },
  userMenuActionIcon: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  userMenuActionTitle: {
    fontWeight: 600,
    fontSize: 13,
    color: '#111827',
    lineHeight: 1.3,
  },
  userMenuActionLogoutTitle: {
    color: '#ef4444',
  },
  userMenuActionSubtitle: {
    fontSize: 11.5,
    color: '#9ca3af',
    lineHeight: 1.4,
    marginTop: 1,
  },
  aiSdrBanner: {
    margin: '16px 12px 20px 12px',
    padding: '0',
    background: '#2a2a2a',
    borderRadius: '12px',
    color: 'white',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
    position: 'relative',
    overflow: 'hidden',
  },
  bannerContent: {
    padding: '16px',
    position: 'relative',
    zIndex: 2,
  },
  bannerTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: 'white !important',
    marginBottom: '4px',
    lineHeight: '1.3',
  },
  bannerSubtitle: {
    fontSize: '11px',
    color: 'rgba(255, 255, 255, 0.7) !important',
    lineHeight: '1.4',
    fontWeight: '400',
    marginBottom: '12px',
  },
  bannerImage: {
    width: '100%',
    height: '120px',
    backgroundImage: `url(${f002Image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: '8px',
    marginBottom: '12px',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(to top, rgba(0,0,0,0.3), transparent)',
      borderRadius: '8px',
    },
  },
  bannerButton: {
    width: '100%',
    padding: '10px 16px',
    background: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    color: '#2a2a2a',
    fontSize: '12px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    '&:hover': {
      background: '#f0f0f0',
      transform: 'translateY(-1px)',
    },
  },
}));

export default useStyles;
